import {Model} from './Model';
import {Event} from './Event';
import {ElementConfig} from './ElementConfig';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

export class DynamicElement extends Model implements SessionStorageObject {
  public title: string = '';
  public eventId: number | null = null;
  public event: Event | null = null;
  public type: number = 0;
  public config!: ElementConfig;

  constructor(data: any) {
    super(data);

    this.title = data.title;
    this.eventId = data.eventId;
    this.type = parseInt(data.type, 10);
    this.config = new ElementConfig(data.config);
  }

  fromStorage(data: any) {
    return new DynamicElement(data);
  }

  toString(): string {
    return `DynamicElement<${this.title}>`;
  }

  public static TYPE_INPUT: number = 1;
  public static TYPE_SELECT: number = 2;
  public static TYPE_RADIO: number = 3;
}
